import createAndSaveQuoteMetadata from 'core/controllerPlans/create-and-save-quote-metadata'
import config from 'sites/enroll.pivothealth.com/start-application/config'
import controller from 'core/controllerPlans'
import once from 'utils/functional/once'
import updateDOM from './updateDOM'
import initDOM from './initDOM'
import finish from './finish'
import { START_APPLICATION } from 'sites/routes'
import './styles.scss'
import sessionHandler from 'core/controllers/sessionHandler'

const saveSession = sessionHandler({
  useState: true,
  save: true
})

const registry = [
  once(initDOM),
  updateDOM,
  once(finish),
  createAndSaveQuoteMetadata(START_APPLICATION),
  once(saveSession)
]

controller(config, registry)
